//index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import '@aws-amplify/ui-react/styles.css';      
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './styles/vars.css';

import App from './App';
import { GlobalProvider } from './context/GlobalContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import authConfig from './authConfig';





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GlobalProvider>
    <React.StrictMode>
      <Router>
        <AuthProvider {...authConfig.generalConf}>
          <App />
        </AuthProvider>
      </Router>
    </React.StrictMode>
  </GlobalProvider>
);

reportWebVitals();
